module.exports = __webpack_public_path__ + "img/new8.ef434206.png";